import { P1CertificatesForm } from './P1CertificatesForm/P1CertificatesForm';
import { P1IdentifierForm } from './P1IdentifierForm/P1IdentifierForm';
import { StyledCommunicationWithP1Separator } from './StyledCommunicationWithP1Separator';

type CommunicationWithP1Props = {
   readonly verifyAccountConfiguration: () => Promise<void>;
};
const CommunicationWithP1 = (props: CommunicationWithP1Props): JSX.Element => {
   return (
      <>
         <P1IdentifierForm verifyAccountConfiguration={props.verifyAccountConfiguration} />
         <StyledCommunicationWithP1Separator />
         <P1CertificatesForm verifyAccountConfiguration={props.verifyAccountConfiguration} />
      </>
   );
};

export { CommunicationWithP1 };
